import { Fragment } from 'react';
import { Link } from 'react-router-dom';

const TOKEN = /(https?:\/\/[^\s,)]*[^\s,).]|\/(?:privacy|terms|cookies|community-guidelines|contact|faq)\b|[\w.+-]+@[\w-]+(?:\.[\w-]+)+)/g;

const renderToken = (t, i) => {
  if (t.startsWith('http')) {
    return <a key={i} href={t} target="_blank" rel="noopener noreferrer" className="text-[#0047FF] underline break-all">{t.replace(/^https?:\/\//, '')}</a>;
  }
  if (t.startsWith('/')) return <Link key={i} to={t} className="text-[#0047FF] underline">{t}</Link>;
  return <a key={i} href={`mailto:${t}`} className="text-[#0047FF] underline">{t}</a>;
};

// Turns URLs, site paths and emails inside plain copy into links.
export const RichText = ({ text }) => (
  <>
    {text.split(TOKEN).map((part, i) => (i % 2 ? renderToken(part, i) : <Fragment key={i}>{part}</Fragment>))}
  </>
);

export const DocBody = ({ body }) =>
  body.map((item, i) => {
    if (typeof item === 'string') {
      return <p key={i} className="text-[#3F3F46] leading-relaxed mb-4"><RichText text={item} /></p>;
    }
    if (item.sub) {
      return <h3 key={i} className="font-heading text-base font-bold text-[#09090B] mt-6 mb-2">{item.sub}</h3>;
    }
    return (
      <ul key={i} className="mb-4 space-y-2 pl-5 list-disc marker:text-[#0047FF]">
        {item.list.map((li, j) => (
          <li key={j} className="text-[#3F3F46] leading-relaxed"><RichText text={li} /></li>
        ))}
      </ul>
    );
  });
